import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { URLEnum } from '../url-enum';
import { SessionModel } from '../interface/session-model';
import { IAMServiceService } from '../service/iamservice.service';
import { AppconfigService } from '../service/appconfig.service';
import { GlobalService } from '../service/global.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router, private IAMServiceService: IAMServiceService, 
    private configService: AppconfigService, private globalService: GlobalService) { }
  isSamlAuth: boolean = false;
  SessionList: SessionModel = new SessionModel();
  showLogoutScreen = this.configService.config.showLogoutScreen;

  ngOnInit(): void {

    sessionStorage.clear();
    this.isSamlAuth = this.SessionList.Saml != undefined && this.SessionList.Saml == 'true' ? true : false
    if (this.router.url.includes('ssoauth/signout')) {
      this.extAuthLogout();
    }
  }

  extAuthLogout() {
    this.IAMServiceService.SAMLSessionInvalidateAll()
      .subscribe(
        (response) => {
          if (response.status == 'success') {

            sessionStorage.clear();

            if (this.showLogoutScreen == 'false') {
              if (this.configService.config.skipSignin == "true") {
                document.location.href = this.configService.config.Saml_windows_login;
              }
              else
                this.router.navigateByUrl(URLEnum.module + URLEnum.samlwindowslogin);
            }
            else {

            }
          }
          else {
            this.SessionList.errorMsg = "Your current session has expired.";
            this.router.navigateByUrl( URLEnum.errorscreenComponent);
          }
        },
        (complete) => {
          console.log('SessionInvalidateAll completed');
        });
  }

  public login() {
    this.globalService.login();
  }

}
